import {ButtonVariant} from "@/app/_components/Button";
import LinkButton from "@/app/_components/LinkButton";

const ConsultationRequiredModalBody = () => {
	return (
		<div className="flex max-w-lg flex-col gap-4 p-8 pt-12">
			<h3 className="text-h4">Start the Admissions Process</h3>
			<p>
				Our admissions process begins with a placement test so that we can
				provide each student with a course placement to allow for the best
				possible learning experience.
			</p>
			<LinkButton
				id="add-class-modal-request-consultation-button"
				className="mt-2 max-w-64 self-center text-sm"
				variant={ButtonVariant.NAVY}
				href="/contact-us"
			>
				GET STARTED
			</LinkButton>
		</div>
	);
};

export default ConsultationRequiredModalBody;
